var render = function render(){var _vm=this,_c=_vm._self._c;return _c('manual-transaction-limits',{attrs:{"manual-transaction-limits":_vm.manualTransactionLimits,"entities-by-id":_vm.entitiesById,"is-loading":_vm.isLoading},on:{"save":_vm.onSaveLimit,"delete":_vm.onDeleteLimit}})
}
var staticRenderFns = []

export { render, staticRenderFns }